export interface MembershipRedirectData {
  is_member?: boolean;
  ui_modules?: string[];
}

export const UI_MODULE_REDIRECTS: { module: string; path: string }[] = [
  { module: 'dashboard', path: '/dashboard' },
  { module: 'settings', path: '/aida-settings' },
  { module: 'histories', path: '/conversations' },
  { module: 'profiles', path: '/profile-and-business' },
  { module: 'knowledge', path: '/knowledge-base' },
  { module: 'chatbox', path: '/chatbox' },
  { module: 'membership', path: '/membership' },
  { module: 'billing', path: '/payments' },
];

const EXACT_PATH_TO_MODULE: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/aida-settings': 'settings',
  '/didar-setting': 'settings',
  '/payments': 'billing',
  '/conversations': 'histories',
  '/profile-and-business': 'profiles',
  '/profile': 'profiles',
  '/business': 'profiles',
  '/channel': 'profiles',
  '/behavior': 'profiles',
  '/chatbox': 'chatbox',
  '/membership': 'membership',
  '/knowledge-base': 'knowledge',
};

const PATH_PREFIX_TO_MODULE: { prefix: string; module: string }[] = [
  { prefix: '/knowledge', module: 'knowledge' },
];

/**
 * Resolves the default landing path after a verified user signs in.
 * Non-members always go to /dashboard.
 * Members are sent to the first allowed ui_module in priority order.
 */
export function getMembershipRedirectPath(
  membership?: MembershipRedirectData | null,
): string {
  if (!membership?.is_member) {
    return '/dashboard';
  }

  const uiModules = membership.ui_modules ?? [];
  for (const { module, path } of UI_MODULE_REDIRECTS) {
    if (uiModules.includes(module)) {
      return path;
    }
  }

  return '/dashboard';
}

export function getUiModuleForPath(pathname: string): string | null {
  if (pathname === '/') {
    return null;
  }

  const exactModule = EXACT_PATH_TO_MODULE[pathname];
  if (exactModule) {
    return exactModule;
  }

  for (const { prefix, module } of PATH_PREFIX_TO_MODULE) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return module;
    }
  }

  return null;
}

export function isPathAllowedForMember(
  pathname: string,
  uiModules: string[],
): boolean {
  const module = getUiModuleForPath(pathname);
  if (!module) {
    return false;
  }
  return uiModules.includes(module);
}
